import { TRADE_MODE_OPTIONS, TRADE_REGIONS, TradeMode, TradeRegion } from '../../model';

export interface GlobalTradeFilterValues {
    modes: TradeMode[];
    regions: TradeRegion[];
    sourceIds: string[];
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);
const stringArray = (value: unknown) =>
    Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];
const tradeRegionSet: ReadonlySet<string> = new Set(TRADE_REGIONS);

export const parseGlobalTradeFilterValues = (value: unknown): GlobalTradeFilterValues => {
    const record = isRecord(value) ? value : {};
    const modes =
        record.modes === undefined
            ? TRADE_MODE_OPTIONS.map((option) => option.value)
            : stringArray(record.modes).filter((mode): mode is TradeMode =>
                  TRADE_MODE_OPTIONS.some((option) => option.value === mode),
              );
    const regions =
        record.regions === undefined
            ? [...TRADE_REGIONS]
            : stringArray(record.regions).filter((region): region is TradeRegion => tradeRegionSet.has(region));

    return {
        modes,
        regions,
        sourceIds: stringArray(record.sourceIds),
    };
};
